
import Vue from 'vue';
import Component from 'vue-class-component';
import Dropzone, { FileStructure } from '../decorators/Dropzone';
import { getModule } from 'vuex-module-decorators';
import SessionsModule from '../store/modules/Sessions';
import store from '../store';
import PhotosModule from '../store/modules/Photos';
import WatermarkDialog from './WatermarkDialog.vue';
import Session from '@/model/Session';
import Watermark from '../model/Watermark';
import UserModule from '../store/modules/User';
import ConfirmFolders from './ConfirmFolders.vue';
import ConfirmationModel from './ConfirmationModel';
import UploadModule from '@/store/modules/Upload';
import {
    confirmRawConversion,
    waitForRawConversionDialogClose,
} from '@/service/rawConversionConfirmation';

const sessionsModule = getModule(SessionsModule, store);
const photosModule = getModule(PhotosModule, store);
const uploadModule = getModule(UploadModule, store);
const userModule = getModule(UserModule, store);

@Component({
    components: {
        WatermarkDialog,
        ConfirmFolders,
    }
})
@Dropzone
export default class NewSessionButton extends Vue {
    public watermarkDialog = false;
    public confirmationModel: ConfirmationModel = new ConfirmationModel();

    mounted() {
        this.$on('globalDragstart', () => this.$el.classList.add('tileDrop'));
        this.$on('globalDragend', () => this.$el.classList.remove('tileDrop'));
        this.$on('dragenter', () => this.$el.classList.add('dropActive'));
        this.$on('dragleave', () => this.$el.classList.remove('dropActive'));

        this.$on('drop', (structure: FileStructure) => this.handleDrop(structure));
    }

    public emitUiRippleFromClick(event: MouseEvent) {
        window.dispatchEvent(new CustomEvent('raws-ui-ripple', {
            detail: {
                x: event.clientX,
                y: event.clientY,
            },
        }));
    }

    public async handleDrop({ allFiles: files, directories }: FileStructure) {
        const directoryMode = directories.length > 1 && await this.confirmationModel.confirm('Jak chcesz utworzyć sesje?');
        const rawConversionDecision = await confirmRawConversion(files);
        if (!rawConversionDecision.confirmed) {
            return;
        }

        let watermark: Watermark = { enabled: false };
        if (files.length > 0) {
            await waitForRawConversionDialogClose(files);
            this.watermarkDialog = true;
            watermark = await new Promise(
                resolve => (this.$refs.watermarkDialog as Vue).$once('watermarkResolved', resolve)
            );
        }
        if (directoryMode) {
            directories.sort((a, b) => a.name > b.name ? 1 : -1);
            for (const directory of directories) {
                const session = await sessionsModule.createNamedSession({ name: directory.name, userId: userModule.user!.id });
                (async () => {
                    await sessionsModule.chooseWatermark({
                        sessionId: session.id,
                        watermark
                    });
                    uploadModule.uploadFiles({
                        files: directory.children.allFiles,
                        session,
                        rawConversionDecision,
                    });
                })();

            }
        } else if (files.length > 0) {
            const session = await sessionsModule.createUnnamedSession(userModule.user!.id);
            sessionsModule.chooseWatermark({
                sessionId: session.id,
                watermark,
            });

            uploadModule.uploadFiles({ files, session, rawConversionDecision });
        }
    }
}
